import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowDown",
  "use": "arrowDown-usage",
  "viewBox": "0 0 22 13",
  "content": "<symbol viewBox=\"0 0 22 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrowDown\">\n<path d=\"M21.0378 1L10.9681 11.0697L0.898438 1\" stroke=\"#C8102E\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol